import React from 'react'

import cn from '../../libs/class-names'

import {ContextMenuContext} from './context-menu'

export interface Props<ComponentType extends React.ElementType = 'a'> {
  as?: 'a' | ComponentType
  classNames?: string[]
  href?: string
  children: React.ReactNode
  onClick?: (event: React.MouseEvent, href: string) => void
  disabled?: boolean
}

const ContextMenuLink = ({
  as = 'a',
  classNames,
  href = '#',
  children,
  onClick,
  disabled = false,
}: Props) => {
  const Component = as
  const {onClose} = React.useContext(ContextMenuContext)

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault()

    if (!disabled) {
      onClose()
      if (onClick) {
        onClick(event, href)
      }
    }
  }

  return (
    <Component
      className={cn('ContextMenuLink', {disabled}, classNames)}
      href={href}
      aria-disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </Component>
  )
}

export default ContextMenuLink
